export enum TransactionSuccess {
  "Ladevorgang läuft",
  "Ladevorgang vorzeitig beendet",
  "Ladevorgang vollständig",
  "Ladevorgang abgebrochen",
}
